<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 11.5H24.5M9.5 16H17.5M9.5 20.5H19.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
